import {
    Locale, createDropdown, Plugin, ButtonView,
} from 'ckeditor5'
import i18n from 'i18next'
import utils from '../utils'

export default class PipeAnswerMergeFields extends Plugin {
    constructor(editor) {
        super(editor)
        this.editor = editor
        this.mergeFields = editor.config.get('custom.mergeFields')
        this.toolbar = editor.config.get('custom.toolbar')
    }

    triggerOnBlur = () => {
        const { view } = this.editor.editing
        if (view) {
            view.focus()
            view.document.fire('blur')
        }
    }

    init() {
        this.editor.ui.componentFactory.add('pipeAnswerMergefield', () => {
            const locale = new Locale()
            const listDropdown = createDropdown(locale)
            listDropdown.set({ panelPosition: 'se' })
            listDropdown.panelView.set({ attributes: { style: { maxWidth: '400px' } } })
            // listDropdown.panelView.element.style.maxWidth = '400px'
            // listDropdown.panelView.element.style.maxHeight = '400px'
            listDropdown.buttonView.set({
                label: i18n.t('merge_field_pipeAnswer_label'),
                withText: true,
                tooltip: i18n.t('merge_field_pipeAnswer_tooltip'),
                icon: utils.infoIcon,
            })

            const collection = listDropdown.panelView.children

            this.mergeFields.filter((mergeField) => mergeField.type === 'pipeAnswer').forEach((mergeField) => {
                const title = i18n.t(`${mergeField.title}`)
                const buttonView = new ButtonView(locale)

                buttonView.set({
                    label: title,
                    withText: true,
                })

                buttonView.on('execute', () => {
                    const value = `[${mergeField.code}]`
                    const viewFragment = this.editor.data.processor.toView(value)
                    const modelFragment = this.editor.data.toModel(viewFragment)
                    this.editor.model.insertContent(modelFragment)
                    listDropdown.isOpen = false
                    this.triggerOnBlur()
                })

                collection.add(buttonView)
            })

            // room to add further mergefields or tags below

            return listDropdown
        })
    }
}
